import {AddressesType} from '../helpers/constants';

export class UserAddress {
  id: number;
  name?: string;
  phoneNumber?: string;
  county: string;
  city: string;
  street: string;
  number: string;
  zipCode: string;
  building: string;
  staircase: string;
  floor: string;
  apartment: string;
  userEmail: string;
  contactPersonName: string;
  contactPersonPhoneNumber: string;
  userId: string;
  isDeleted: boolean;
  type: AddressesType;  // 1 - shipping, 2 - billing

}
